import type { AuditEntityType } from '@cult/domain';
import { type AuditLogResponse, AuditLogResponseSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';

export const auditKeys = {
  all: ['audit'] as const,
  entity: (entityType: AuditEntityType, entityId: string) => [...auditKeys.all, entityType, entityId] as const,
};

export const useAuditLog = (entityType: AuditEntityType, entityId: string) =>
  useQuery<AuditLogResponse>({
    queryKey: auditKeys.entity(entityType, entityId),
    queryFn: async () => {
      const params = new URLSearchParams({ entityType, entityId });
      return AuditLogResponseSchema.parse(await apiFetch<unknown>(`/audit-log?${params.toString()}`));
    },
    staleTime: 30_000,
  });
